import { Controller } from '@hotwired/stimulus';

/**
 * Connects to data-controller="no-turbo-visits"
 *
 * When a view is rendered inside an iframe, this controller ensures that Turbo visits navigate the
 * parent window instead of the iframe. Turbo Frame navigations continue to work normally within the
 * iframe.
 *
 * We usually want to navigate the parent window because otherwise we would duplicate the header and
 * footer. This is not the case if the inline_view query parameter is provided. Then the visit is
 * intended for the iframe and this controller doesn't interfere.
 */
export default class extends Controller {
  connect() {
    // Check if we're in an iframe.
    if (window === window.parent) {
      return;
    }

    this.beforeVisitHandler = this.handleBeforeVisit.bind(this);
    document.addEventListener('turbo:before-visit', this.beforeVisitHandler);
  }

  disconnect() {
    document.removeEventListener('turbo:before-visit', this.beforeVisitHandler);
  }

  handleBeforeVisit(event) {
    // Don't interfere if the response should be rendered in the iframe.
    const url = new URL(event.detail.url);
    if (url.searchParams.has('inline_view')) {
      return;
    }

    // For all other visits, navigate the parent window
    event.preventDefault();
    window.parent.location.href = event.detail.url;
  }
}
